<div *ngIf="control.invalid && control.touched">
  {{ errorMessage | translate }}
</div>
